// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"45d364a1","388":"99297cf6","617":"d88fe7f4","724":"ba2fc6fb","756":"557cb460","819":"6ef9d652","896":"b3664389","923":"34b21dca"}[chunkId] + ".chunk.js";
};